import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { RxHamburgerMenu, RxCross2 } from "react-icons/rx";
import { FiChevronDown } from "react-icons/fi";
import TopBar from "./TopBar";

function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [expandedMobileSection, setExpandedMobileSection] = useState(null);
  const [specialRoute, setSpecialRoute] = useState(false);
  const headerWrapRef = useRef(null);

  const location = useLocation();

  const toggleMobileSection = (key) => {
    setExpandedMobileSection((prev) => (prev === key ? null : key));
  };

  const closeMobileMenu = () => {
    setIsMenuOpen(false);
    setExpandedMobileSection(null);
  };
  
  // Check if current path matches dropdown items
  const isAboutActive = 
    location.pathname === "/company-overview" ||
    location.pathname === "/leadership-advisors";
  
  const isSolutionsActive =
    location.pathname === "/web-builder" ||
    location.pathname === "/laris" ||
    location.pathname === "/maps" ||
    location.pathname === "/quest";
  
  const isResourcesActive =
    location.pathname === "/blogs" ||
    location.pathname === "/faqs";

  useEffect(() => {
    // Determine if the current route is special
    if (
      // location.pathname === "/laris" ||
      location.pathname === "/quest"
      // location.pathname === '/pharmacy-software' ||
      // location.pathname === "/web-builder"
    ) {
      setSpecialRoute(true);
    } else {
      setSpecialRoute(false);
    }
  }, [location.pathname]);
  const isHomePage = location.pathname === "/";

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset;
      if (scrollTop > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [isMenuOpen]);

  // On homepage, use scrolled navbar style to match other pages
  const navbarScrolled = isScrolled || isHomePage;

  // Measure fixed header (TopBar + Navbar) height and expose as a CSS variable
  useEffect(() => {
    const updateHeaderHeightVar = () => {
      const wrap = headerWrapRef.current;
      if (!wrap) return;

      const topBarEl = wrap.querySelector(".top-bar");
      const navEl = wrap.querySelector(".navbar.fixed-top");

      const topBarH = topBarEl ? topBarEl.offsetHeight : 0;
      const navH = navEl ? navEl.offsetHeight : 0;
      const total = topBarH + navH;

      // Provide a sane minimum fallback so content never hides behind header
      const safeTotal = Math.max(total, 70);
      document.documentElement.style.setProperty(
        "--app-header-height",
        `${safeTotal}px`
      );
    };

    // Run immediately + after layout settles
    updateHeaderHeightVar();
    const raf = window.requestAnimationFrame(updateHeaderHeightVar);

    window.addEventListener("resize", updateHeaderHeightVar);
    return () => {
      window.cancelAnimationFrame(raf);
      window.removeEventListener("resize", updateHeaderHeightVar);
    };
  }, [isMenuOpen, isScrolled]);

  const handleMenuClick = () => {
    setIsMenuOpen((prev) => {
      if (prev) setExpandedMobileSection(null);
      return !prev;
    });
  };

  return (
    <div className="app-header" ref={headerWrapRef}>
      <TopBar isScrolled={isScrolled} />
      <header
        className={`header ${navbarScrolled ? "scrolled" : ""} ${
          specialRoute ? "scrolled-2" : ""
        }`}
      >
        {/* Navbar */}
        <nav
          className={`navbar navbar-expand-lg fixed-top custom-nav ${
            navbarScrolled ? "scrolled" : ""
          } ${isMenuOpen ? "mobile-drawer-open" : ""}`}
        >
          <div className="container p-0">
            <Link className="navbar-brand" to="/">
              <img src="/assets/logo.png" alt="logo" className="img-fluid" />
            </Link>
            <button type="button" className="hamburger" onClick={handleMenuClick} aria-label={isMenuOpen ? "Close menu" : "Open menu"} aria-expanded={isMenuOpen}>
              {isMenuOpen ? <RxCross2 aria-hidden /> : <RxHamburgerMenu aria-hidden />}
            </button>

            {/* Desktop menu - dropdowns on hover */}
            <div
              className={`collapse navbar-collapse h-auto desktop-nav-wrap ${
                isMenuOpen ? "show" : ""
              }`}
              id="navbarSupportedContent"
            >
              <ul className="navbar-nav ml-auto menu desktop-menu">
                <li>
                  <Link 
                    to="/" 
                    className={`page-scroll ${location.pathname === "/" ? "active" : ""}`}
                  >
                    Home
                  </Link>
                </li>
                <li>
                  <Link 
                    to="#" 
                    className={`dropdown-toggle ${isAboutActive ? "active" : ""}`}
                  >
                    About
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link 
                        to="/company-overview"
                        className={location.pathname === "/company-overview" ? "active" : ""}
                      >
                        Company Overview
                      </Link>
                    </li>
                    <li>
                      <Link 
                        to="/leadership-advisors"
                        className={location.pathname === "/leadership-advisors" ? "active" : ""}
                      >
                        Leadership & Advisors
                      </Link>
                    </li>
                  </ul>
                </li>
                <li>
                  <Link 
                    to="#" 
                    className={`dropdown-toggle ${isSolutionsActive ? "active" : ""}`}
                  >
                    Solutions
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link 
                        to="/web-builder"
                        className={location.pathname === "/web-builder" ? "active" : ""}
                      >
                        Web Builder
                      </Link>
                    </li>
                    <li>
                      <Link 
                        to="/laris"
                        className={location.pathname === "/laris" ? "active" : ""}
                      >
                        LARIS
                      </Link>
                    </li>
                    <li>
                      <Link 
                        to="/maps"
                        className={location.pathname === "/maps" ? "active" : ""}
                      >
                        MAPS
                      </Link>
                    </li>
                    <li>
                      <Link 
                        to="/quest"
                        className={location.pathname === "/quest" ? "active" : ""}
                      >
                        Quest
                      </Link>
                    </li>
                  </ul>
                </li>
                <li>
                  <Link 
                    to="#" 
                    className={`dropdown-toggle ${isResourcesActive ? "active" : ""}`}
                  >
                    Resources
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link 
                        to="/blogs"
                        className={location.pathname === "/blogs" ? "active" : ""}
                      >
                        Blogs
                      </Link>
                    </li>
                    <li>
                      <Link 
                        to="/faqs"
                        className={location.pathname === "/faqs" ? "active" : ""}
                      >
                        FAQs
                      </Link>
                    </li>
                  </ul>
                </li>
                <li>
                  <Link 
                    to="/contact-us" 
                    className={`page-scroll ${location.pathname === "/contact-us" ? "active" : ""}`}
                  >
                    Contact Us
                  </Link>
                </li>
              </ul>
              <Link 
                to="/request-a-demo" 
                className="btn btn-brand-02 nav-cta-button"
              >
                Request a Demo
              </Link>
            </div>

            {/* Mobile slide-out drawer - accordion-style submenus */}
            <div
              className={`mobile-nav-drawer ${isMenuOpen ? "mobile-nav-drawer--open" : ""}`}
              aria-hidden={!isMenuOpen}
            >
              <div className="mobile-nav-drawer__backdrop" onClick={closeMobileMenu} aria-label="Close menu" />
              <div className="mobile-nav-drawer__panel">
                <div className="mobile-nav-drawer__header">
                  <span className="mobile-nav-drawer__title">Explore</span>
                  <button
                    type="button"
                    className="mobile-nav-drawer__close"
                    onClick={closeMobileMenu}
                    aria-label="Close menu"
                  >
                    <RxCross2 aria-hidden />
                  </button>
                </div>
                <nav className="mobile-nav-drawer__nav">
                  <Link 
                    to="/" 
                    className={`mobile-nav-drawer__link ${location.pathname === "/" ? "active" : ""}`}
                    onClick={closeMobileMenu}
                  >
                    Home
                  </Link>
                  <div className="mobile-nav-drawer__accordion">
                    <button
                      type="button"
                      className={`mobile-nav-drawer__accordion-trigger ${isAboutActive ? "active" : ""}`}
                      onClick={() => toggleMobileSection("about")}
                      aria-expanded={expandedMobileSection === "about"}
                    >
                      About
                      <FiChevronDown className={`mobile-nav-drawer__chevron ${expandedMobileSection === "about" ? "expanded" : ""}`} aria-hidden />
                    </button>
                    <div className={`mobile-nav-drawer__submenu ${expandedMobileSection === "about" ? "expanded" : ""}`}>
                      <Link to="/company-overview" className={location.pathname === "/company-overview" ? "active" : ""} onClick={closeMobileMenu}>Company Overview</Link>
                      <Link to="/leadership-advisors" className={location.pathname === "/leadership-advisors" ? "active" : ""} onClick={closeMobileMenu}>Leadership & Advisors</Link>
                    </div>
                  </div>
                  <div className="mobile-nav-drawer__accordion">
                    <button
                      type="button"
                      className={`mobile-nav-drawer__accordion-trigger ${isSolutionsActive ? "active" : ""}`}
                      onClick={() => toggleMobileSection("solutions")}
                      aria-expanded={expandedMobileSection === "solutions"}
                    >
                      Solutions
                      <FiChevronDown className={`mobile-nav-drawer__chevron ${expandedMobileSection === "solutions" ? "expanded" : ""}`} aria-hidden />
                    </button>
                    <div className={`mobile-nav-drawer__submenu ${expandedMobileSection === "solutions" ? "expanded" : ""}`}>
                      <Link to="/web-builder" className={location.pathname === "/web-builder" ? "active" : ""} onClick={closeMobileMenu}>Web Builder</Link>
                      <Link to="/laris" className={location.pathname === "/laris" ? "active" : ""} onClick={closeMobileMenu}>LARIS</Link>
                      <Link to="/maps" className={location.pathname === "/maps" ? "active" : ""} onClick={closeMobileMenu}>MAPS</Link>
                      <Link to="/quest" className={location.pathname === "/quest" ? "active" : ""} onClick={closeMobileMenu}>Quest</Link>
                    </div>
                  </div>
                  <div className="mobile-nav-drawer__accordion">
                    <button
                      type="button"
                      className={`mobile-nav-drawer__accordion-trigger ${isResourcesActive ? "active" : ""}`}
                      onClick={() => toggleMobileSection("resources")}
                      aria-expanded={expandedMobileSection === "resources"}
                    >
                      Resources
                      <FiChevronDown className={`mobile-nav-drawer__chevron ${expandedMobileSection === "resources" ? "expanded" : ""}`} aria-hidden />
                    </button>
                    <div className={`mobile-nav-drawer__submenu ${expandedMobileSection === "resources" ? "expanded" : ""}`}>
                      <Link to="/blogs" className={location.pathname === "/blogs" ? "active" : ""} onClick={closeMobileMenu}>Blogs</Link>
                      <Link to="/faqs" className={location.pathname === "/faqs" ? "active" : ""} onClick={closeMobileMenu}>FAQs</Link>
                    </div>
                  </div>
                  <Link 
                    to="/contact-us" 
                    className={`mobile-nav-drawer__link ${location.pathname === "/contact-us" ? "active" : ""}`}
                    onClick={closeMobileMenu}
                  >
                    Contact Us
                  </Link>
                  <Link 
                    to="/request-a-demo" 
                    className="mobile-nav-drawer__cta"
                    onClick={closeMobileMenu}
                  >
                    Request a Demo
                  </Link>
                </nav>
              </div>
            </div>
          </div>
        </nav>
      </header>
    </div>
  );
}

export default Header;
